import styled, { css } from "styled-components";

const BlankScreenStyled = styled.div`
    width: 100%;
    height: ${props => (props.$fullPage ? "100vh" : "50rem")};
    background: white;

    ${props => {
        return (
            props.$fullPage &&
            css`
                position: fixed;
                top: 0;
                left: 0;
                z-index: 999;
            `
        );
    }}
`;

export default BlankScreenStyled;
